<template>
  <div>
    <button
      type="button"
      class="btn btn-dark btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk Fee Update
    </button>

    <a-modal v-model="visible" title="Bulk Fee Update" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update</a-button>
      </template>

      <a-form :form="form">
<!--        <p>Select Session and class section to upload students.</p>
        <div class="row">
          <div class="col-md-4 mb-2">
            <a-form-item
              label="Session"
            >
              <a-select
                v-decorator="[
                  'session_id',
                  {rules: [{ required: true, message: 'Please select a session!!' }], initialValue: currentSession ? currentSession.id : ''}
                ]"
                placeholder="Select session"
                @change="handleSessionChange"
              >
                <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-3">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4 mb-2">
            <a-form-item
              label="Class"
            >
              <a-spin :spinning="classSpinning">
                <a-select
                  v-decorator="[
                    'class_id',
                    {rules: [{ required: false, message: 'Please select a class!!' }], initialValue: undefined}
                  ]"
                  placeholder="Select class"
                  @change="handleClassSelect"
                  :disabled="!selectedSession"
                >
                  <a-select-option :value="undefined">
                    Select Class
                  </a-select-option>
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

          <div class="col-md-4 mb-2">
            <a-form-item
              label="Section"
            >
              <a-spin :spinning="sectionSpinning">
                <a-select
                  v-decorator="[
                    'section_id',
                    {rules: [{ required: false, message: 'Please select a section!!' }], initialValue: undefined}
                  ]"
                  placeholder="Select section"
                  :disabled="!form.getFieldValue('class_id')"
                >
                    <a-select-option :value="undefined">
                      Select Section
                    </a-select-option>
                    <a-select-option v-for="section in sections" :value="section.id" :key="section.id">
                    {{section.name}}
                    </a-select-option>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

        </div>

        <a-divider /> -->
        <div class="row">
          <div class="col-md-6 mb-2">
          <a-form-item label="Class">
            <a-spin :spinning="sectionSpinning">
              <a-select
                v-decorator="[`class_ids`,{rules: [{ required: false, message: 'Please select classes' },],initialValue: [],},]"
                placeholder="Select fee"
                mode="multiple"
                style="width: 100%"
              >
                <a-select-option
                  v-for="schoolClass in schoolClasses"
                  :value="schoolClass.id"
                  :key="schoolClass.id"
                >
                  {{ schoolClass.name }}
                </a-select-option>
              </a-select>
            </a-spin>
          </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Fees"
            >
              <a-select
                v-decorator="[
                    'fee_ids',
                    {rules: [{ required: true, message: 'Please select a fee to be paid.' }], initialValue: undefined}
                  ]"
                placeholder="Select fee"
                mode="multiple"
              >
                <a-select-option :value="undefined">
                  Select Fee
                </a-select-option>
                <a-select-option v-for="fee in fees" :value="fee.id" :key="fee.id">
                  {{fee.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Student Codes (In comma seperated)"
            >
              <a-input placeholder="Student code"
                       v-decorator="['student_codes', {rules: [{ required: false, message: 'Please input student codes!' }]}]"></a-input>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Discount Amount(Rs.)"
            >
              <a-input-number placeholder="Discount amount"
                       v-decorator="['discount_amount', {rules: [{ required: false, message: 'Please input discount amount!' }]}]"></a-input-number>
            </a-form-item>
          </div>
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Discount %"
            >
              <a-input-number placeholder="Discount percent"
                              v-decorator="['discount_percentage', {rules: [{ required: false, message: 'Please input discount percentage!' }]}]"></a-input-number>
            </a-form-item>
          </div>
<!--          <div class="col-md-6 mb-2">
            <a-form-item>
              <a-checkbox :disabled="true" v-decorator="['only_undiscounted_student',{valuePropName: 'checked', initialValue: true,}]">Only undiscounted student</a-checkbox>
            </a-form-item>
          </div>-->
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'

export default {
  name: 'BulkFeeUpdate',
  mounted: function() {
    this.$http.get(`/api/fee`, {
    })
      .then(({ data }) => {
        this.fees = data.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedSession: undefined,
      classSpinning: false,
      sectionSpinning: false,
      fees: [],
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.callSchoolClassesAPI()
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to make bulk fee update.`,
            onOk: () => {
              /* let formData = window.jsonToFormData(values, options)
              const csvFile = values.file.file
              formData.append('file', csvFile) */
              console.log(values)
              values.student_codes = values.student_codes.split(',')
              console.log(values)
              this.$http
                .post('/api/fee_setting/bulk_student_fee_update', values)
                .then(({ data }) => {
                  this.loading = false
                  this.visible = false
                  this.$notification['info']({
                    message: 'Bulk fee updated successful!',
                    description: `Bulk fee updated successful!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
    callSchoolClassesAPI() {
      this.$http.get(`/api/class`, {
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
